import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var RedoIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.021 4.13606C11.183 3.67606 10.222 3.41606 9.19701 3.41606C5.88301 3.41606 3.19701 6.10206 3.19701 9.41606C3.19701 12.7301 5.88301 15.4161 9.19701 15.4161C11.412 15.4161 13.325 14.2021 14.365 12.4161H11.817C11.114 13.0311 10.205 13.4161 9.19701 13.4161C6.98801 13.4161 5.19701 11.6251 5.19701 9.41606C5.19701 7.20706 6.98801 5.41606 9.19701 5.41606C9.85801 5.41606 10.476 5.58206 11.019 5.87106L12.021 4.13606ZM13.254 2.00006L9.254 8.92806L15.584 7.96406L13.254 2.00006Z"
  }));
});
RedoIcon.displayName = 'RedoIcon';
export default RedoIcon;